import { render, staticRenderFns } from "./Salutations.vue?vue&type=template&id=4e7b7e26"
import script from "./Salutations.vue?vue&type=script&lang=js"
export * from "./Salutations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports